import React from "react";
import SearchWeather from "./components/SearchWeather";

function App() {
  return (
    <div>
      <SearchWeather />
    </div>
  );
}

export default App;
